import { render, staticRenderFns } from "./WeekCalendar.vue?vue&type=template&id=c6bf9298&scoped=true"
import script from "./WeekCalendar.vue?vue&type=script&lang=js"
export * from "./WeekCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bf9298",
  null
  
)

export default component.exports